import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import type { ButtonAsAnchorProps } from '@noths/polaris-design-system-core-components';
import { Button } from '@noths/polaris-design-system-core-components';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import { trackImpression } from 'src/tracking/common/trackImpression';
import { trackLinkClick } from 'src/tracking/components/button';
import type { TrackingContext } from 'src/types/TrackingContext';
import * as styles from './ButtonSection.styles';

export interface ButtonSectionProps extends Omit<ButtonAsAnchorProps, 'compact'> {
  trackingPosition?: number;
  trackingTitle: string;
}

export const ButtonSection = ({
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: ButtonSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'CTA button',
  };
  const buttonRef = useImpressionRef<HTMLDivElement>(() => trackImpression(trackingContext));

  return (
    <SectionContainer columnsXL={10} maxWidth="full" ref={buttonRef} wrapperStyles={styles.wrapper}>
      <Button
        {...restOfProps}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => trackLinkClick(e, trackingContext)}
      />
    </SectionContainer>
  );
};

export type { ButtonTextColorMode } from '@noths/polaris-client-ribbons-design-system';
